import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  attachmentInPG: [],
  allAttachmentsInPG: []
};

export const AttachmentsInPGSlice = createSlice({
  name: "attachmentsInPG",
  initialState,
  reducers: {
    getAllAttachmentsInPGAction: (state, action) => {
      state.allAttachmentsInPG = action.payload;
    },
    getAttachmentsInPGAction: (state, action) => {
      
      state.attachmentInPG = action.payload;
    }
  },
});

export default AttachmentsInPGSlice.reducer;

export const { getAllAttachmentsInPGAction, getAttachmentsInPGAction } = AttachmentsInPGSlice.actions;
